import styled from "styled-components";
import { smokeWhite } from "../../common/style";

export default styled.div`

`
